import PropTypes from 'prop-types'
import AssetPath from '../../Screens/AssetPath/AssetPath'

function LoaderBox({ loader, loadingText = 'Loading..', loadingDescription = '', noData, style }) {
  return (
    <>
      {loader && (
        <div className="loading-content" style={style}>
          <img className="loader" src={AssetPath.brand.aksaIcon} alt="Loading" />
          <h3 className="font-title">{loader === true ? <div>{loadingText}</div> : loader}</h3>
          {loadingDescription && (
            <center>
              <b>{loadingDescription}</b>
            </center>
          )}
        </div>
      )}
      {!loader && noData && (
        <div className="loading-content" style={style}>
          <img src={AssetPath.brand.aksaIcon} alt="No Data found" />
          <h1 className="font-title">{noData === true ? 'No Data found..' : noData}</h1>
        </div>
      )}
    </>
  )
}

LoaderBox.propTypes = {
  loader: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  noData: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  style: PropTypes.object
}

export default LoaderBox
